<template>
<div
  class="tickets-list"
  v-loading="loadingCustomers || loadingEvents || loadingTickets || loadingFiltered"
>
  <div class="card">
    <div class="card-header">
      <h4 class="card-title">
        <i class="ti-ticket"></i> {{ getTitle }} ({{ ticketsFiltered.length }})
      </h4>
    </div>

    <div class="card-content">
      <div
        v-if="showResume"
        class="row"
      >
        <div class="col-md-6">
          <el-select
            @change="setTicketsFiltered"
            multiple
            filterable
            class="select-primary el-select"
            size="large"
            v-model="filters.selected"
            placeholder="Filtros"
          >

            <el-option
              v-for="option in filtersOptions"
              class="select-primary"
              :value="option.value"
              :label="option.label"
              :key="option.value"
            />

          </el-select>
        </div>

        <div class="col-md-6">
          <p-search
            @on-search="handleSearch($event)"
            placeholder="Pesquise por Nome Completo, CPF, UC ou Cod. do Ticket"
          />
        </div>
      </div>

      <div v-loading="loadingFiltered" class="row">
        <div class="col-md-12">
          <el-table
            class="table-striped"
            :data="ticketsFiltered"
            :default-sort="{prop: 'createdAt', order: 'descending'}"
          >
            <el-table-column
              v-if="showCustomerColumn"
              label="UC"
              property="customerId.uc"
              min-width="100"
              sortable
            >
              <template slot-scope="scope">
                <button
                  v-if="$can('tickets.print')"
                  class="btn btn-info"
                  title="Informações do Cliente"
                  @click="customerInfo(customers[scope.row.customerId])"
                >
                  {{ customers[scope.row.customerId].uc }}
                </button>
              </template>
            </el-table-column>

            <el-table-column
              v-if="showCustomerColumn"
              label="Cliente"
              property="customerId"
              min-width="200"
            >
              <template slot-scope="scope">
              <el-popover
                trigger="hover"
                placement="top"
                v-if="customers[scope.row.customerId]"
              >
                <p>
                  <b>Nome Completo:</b> {{ customers[scope.row.customerId].holder }}<br/>
                  <b>CPF:</b> {{ customers[scope.row.customerId].cpf }}<br/>
                  <b>UC:</b> {{ customers[scope.row.customerId].uc }}
                  <b>Código de barra:</b> {{ scope.row.barcode }}
                </p>
                <div
                  slot="reference"
                  class="name-wrapper"
                >
                  <a @click="handleDocumentation(scope.row)">
                    <i class="ti-info-alt"></i> {{ customers[scope.row.customerId].holder }}
                  </a>
                </div>
              </el-popover>
              </template>
            </el-table-column>

            <el-table-column
              v-if="showEventColumn"
              label="Evento"
            >
              <template slot-scope="props">
              <span v-if="event">
                    {{ event.city }} -
                    {{ event.reference }}
                </span>
              <span v-else-if="events.hasOwnProperty(props.row.eventId)">
                  {{ events[props.row.eventId].city }} -
                  {{ events[props.row.eventId].reference }}
                </span>
              </template>
            </el-table-column>

            <el-table-column>
              <template slot-scope="scope">
              <icons-ticket-list
                :ticket="scope.row"
                :reason="reason(scope.row)"
                :not-eligible="notEligible(scope.row)"
              ></icons-ticket-list>
              </template>
            </el-table-column>

            <el-table-column
              label="Código do ticket"
              property="barcode"
            >
              <template slot-scope="props">
              {{ props.row.barcode }}
              </template>
            </el-table-column>

            <el-table-column
              label="Data de Criação"
              property="createdAt"
              width="150"
              sortable
            >
              <template slot-scope="scope">
              {{ new Date(scope.row.createdAt) | moment('L') }}
              </template>
            </el-table-column>
            <el-table-column
              label="Ações"
              fixed="right"
            >
              <template slot-scope="scope">
              <div
                class="text-right"
                v-loading="loadingTickets"
              >
                <ticket-check-in
                  :ticket="scope.row"
                  :icon="true"
                  :event-id="scope.row.eventId"
                ></ticket-check-in>

                <check-energy-metering-tickets
                  :ticket="scope.row"
                  @changeTickets="changeTickets"
                ></check-energy-metering-tickets>

                <check-valid-online-register
                  :ticket="scope.row"
                  :type="event ? 'event' : 'customer'"
                ></check-valid-online-register>

                 <ticket-invalidate-error
                  :event="event"
                  :ticket="scope.row"
                  :type="event ? 'event' : 'customer'"
                ></ticket-invalidate-error>

                <button
                  v-if="enableReplace(scope.row)"
                  class="btn btn-fill btn-icon btn-info"
                  title="Substituir"
                  @click="handleReplaceCustomer(scope.$index, scope.row)"
                >
                  <i class="ti-control-shuffle"></i></button>

                <btn-open-ticket-documentation
                  :event="getEvent(scope.row.eventId)"
                  :ticket="scope.row"
                  :scope="scope"
                />

                <btn-open-tickets-documentations-print v-if="!scope.row.error" :ticket="scope.row"/>
                <BtnOpenTicketRegisterDocPrint
                  :event-prop="event"
                  :ticket="scope.row"
                ></BtnOpenTicketRegisterDocPrint>
                <btn-open-ticket-print v-if="!scope.row.error" :ticket="scope.row"/>
              </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>

  <el-dialog
    title="Substituição de cliente sorteado"
    :modal-append-to-body="false"
    :modal="true"
    :visible.sync="replacementCustomerSync"
  >
    <replacement-customer
      v-if="showReplacement"
      :oldWinner="winner"
      :tickets="tickets"
      :customers="customers"
      :automatic="config.event.automaticReplacement"
      :replacementCustomerSync="replacementCustomerSync"
      @handleTicketPrint="handleTicketPrint"
    />

  </el-dialog>
</div>
</template>

<script>
import Fuse from 'fuse.js'
import BtnOpenTicketDocumentation from 'src/pages/Tickets/Actions/BtnOpenTicketDocumentation'
import BtnOpenTicketPrint from 'src/pages/Tickets/Actions/BtnOpenTicketPrint'
import BtnOpenTicketsDocumentationsPrint from 'src/pages/Tickets/Actions/BtnOpenTicketsDocumentationsPrint'
import CheckEnergyMeteringTickets from './Actions/CheckEnergyMeteringTickets'
import CheckValidOnlineRegister from './Actions/CheckValidOnlineRegister'
import TicketCheckIn from 'src/pages/Tickets/Actions/TicketCheckIn'
import TicketInvalidateError from 'src/pages/Tickets/Actions/TicketInvalidateError'
import ReplacementCustomer from 'src/pages/Tickets/ReplacementCustomer'
import Couchdb from 'src/services/Couchdb'
import { mapActions, mapGetters } from 'vuex'
import IconsTicketList from './IconsTicketList'
import BtnOpenTicketRegisterDocPrint from './Actions/BtnOpenTicketRegisterDocPrint'
import swal from 'sweetalert2'

export default {
  name: 'tickets-list',
  components: {
    BtnOpenTicketRegisterDocPrint,
    BtnOpenTicketPrint,
    BtnOpenTicketsDocumentationsPrint,
    BtnOpenTicketDocumentation,
    ReplacementCustomer,
    TicketCheckIn,
    TicketInvalidateError,
    IconsTicketList,
    CheckEnergyMeteringTickets,
    CheckValidOnlineRegister
  },

  props: {
    event: {},

    tickets: {
      type: Array,
      required: true
    },

    customers: {
      type: Object,
      required: true
    },

    scope: {
      type: String,
      default: 'customer'
    },

    loading: {
      type: Boolean,
      default: true
    }
  },

  mounted () {
    this.setFilters()
    this.setTicketsFiltered()
  },

  data () {
    return {
      loadingFiltered: false,
      page: 1,
      perPage: 30,
      search: '',
      replacementCustomerSync: false,
      winner: {},
      filters: {
        selected: []
      },
      showReplacement: false,
      ticketsFiltered: []
    }
  },

  watch: {
    event () {
      this.setFilters()
      this.setTicketsFiltered()
    },
    tickets () {
      this.setTicketsFiltered()
    }
  },

  computed: {
    ...mapGetters(['config']),

    loadingCustomers: {
      get () {
        return this.$store.state.customers.loading
      }
    },

    loadingEvents: {
      get () {
        return this.$store.state.events.loading
      }
    },

    loadingTickets: {
      get () {
        return this.$store.state.tickets.loading
      }
    },

    isEventRanking () {
      return this.event && this.event.winnerChoiceMode === 'ranking'
    },

    surveys: {
      get () {
        return this.$store.state.surveys.all.reduce((accumulate, current, index) => {
          if (index === 0) {
            accumulate = {}
          }
          accumulate[current.ticketId] = current
          return accumulate
        }, {})
      }
    },

    filtersOptions () {
      let options = [
        { value: 'winner', label: 'Ganhadores' },
        { value: 'checkIn', label: 'Presentes' },
        { value: 'valid', label: 'Válidos' },
        { value: 'invalid', label: 'Inválidos' },
        { value: 'notCheckIn', label: 'Ausentes' },
        { value: 'eligible', label: 'Aptos' },
        { value: 'unlegible', label: 'Inaptos' },
        { value: 'documented', label: 'Documentados' },
        { value: 'notDocumented', label: 'Não Documentados' },
        { value: 'withStock', label: 'Com Estoque' },
        { value: 'withoutStock', label: 'Sem Estoque' },
        { value: 'nonValid', label: 'Pendentes' }
      ]
      if (this.isEventRanking) {
        options.push({ value: 'surveyed', label: 'Pesquisados' })
        options.push({ value: 'notSurveyed', label: 'Não Pesquisados' })
      }
      return options
    },

    showCustomerColumn () {
      return this.scope === 'event' && this.customers
    },

    showEventColumn () {
      return this.scope === 'customer'
    },

    showResume () {
      return this.scope === 'event'
    },

    getTitle () {
      let alreadyOne = false
      let title = this.filters.selected.length > 0 ? 'Tickets' : 'Tickets Gerados'
      let max = this.filters.selected.length - 1
      for (let id in this.filters.selected) {
        let option = this.filtersOptions.find(option => option.value === this.filters.selected[id])
        if (!alreadyOne) {
          alreadyOne = true
          title = `${title} ${option.label}`
        } else {
          title = id === max ? `${title} e ${option.label}` : `${title}, ${option.label}`
        }
      }
      return title
    },

    eventIsDrawn () {
      return typeof this.event !== 'undefined' && this.event.hasOwnProperty(
        'drawn') && this.event.drawn === true
    },

    events: {
      get () {
        return this.$store.state.events.all.reduce((accumulate, current, index) => {
          accumulate = index === 0 ? {} : accumulate
          accumulate[current._id] = current
          return accumulate
        }, {})
      }
    }
  },

  methods: {
    ...mapActions(
      'tickets',
      ['setChangeCheckInWinner', 'resetOne', 'getTicketsByEvent', 'getTicketsByCustomer']
    ),

    customerInfo (customer) {
      if (customer.phone2 === '') {
        return swal({
          title: `${customer.holder}`,
          text: `UC: ${customer.uc},
          CPF: ${customer.cpf},
          Endereço: ${customer.address.street}, 
          ${customer.address.number}, 
          ${customer.address.neighborhood}, 
          ${customer.address.city}. 
          Telefone: ${customer.phone1}`
        })
      } else {
        return swal({
          title: `${customer.holder}`,
          text: `UC: ${customer.uc},
          CPF: ${customer.cpf},
          Endereço: ${customer.address.street}, 
          ${customer.address.number}, 
          ${customer.address.neighborhood}, 
          ${customer.address.city}. 
          Telefone 1: ${customer.phone1}, 
          Telefone 2: ${customer.phone2}`
        })
      }
    },

    setTicketsFiltered () {
      let filteredTickets = this.tickets
      this.loadingFiltered = true
      if (this.search !== '') {
        let options = {
          threshold: 0.0,
          keys: ['barcode', 'customer.cpf', 'customer.holder', 'customer.uc']
        }
        let fuse = new Fuse(filteredTickets.map(item => {
          item.customer = this.customers[item.customerId]
          return item
        }), options)

        filteredTickets = fuse.search(this.search).map(item => {
          delete item.customer
          return item
        })
      }
      // console.log(filteredTickets)
      this.ticketsFiltered = this.filters.selected.length === 0 ? filteredTickets : filteredTickets.filter(
        ticket => {
          return this.filters.selected.indexOf('winner') === -1 || ticket.winner
        })
        .filter(ticket => {
          return this.filters.selected.indexOf('eligible') === -1 || this.ticketEligible(
            ticket)
        })
        .filter(ticket => {
          return this.filters.selected.indexOf('unlegible') === -1 || this.notEligible(
            ticket)
        })
        .filter(ticket => {
          return this.filters.selected.indexOf('valid') === -1 || (!ticket.error && ticket.valid && ticket.cadastroOnline)
        })
        .filter(ticket => {
          return this.filters.selected.indexOf('invalid') === -1 || (ticket.error && ticket.cadastroOnline && ticket.reasonError)
        })
        .filter(ticket => {
          return this.filters.selected.indexOf('checkIn') === -1 || ticket.checkIn
        })
        .filter(ticket => {
          return this.filters.selected.indexOf('notCheckIn') === -1 || !ticket.checkIn
        })
        .filter(ticket => {
          return this.filters.selected.indexOf('documented') === -1 || (ticket.hasOwnProperty('documentedAt') && ticket.documentedAt !== null)
        })
        .filter(ticket => {
          return this.filters.selected.indexOf('notDocumented') === -1 || (ticket.documentedAt === null || !ticket.hasOwnProperty('documentedAt'))
        })
        .filter(ticket => {
          return this.filters.selected.indexOf('withStock') === -1 || ticket.stockId !== null
        })
        .filter(ticket => {
          return this.filters.selected.indexOf('withoutStock') === -1 || ticket.stockId === null
        })
        .filter(ticket => {
          return this.filters.selected.indexOf('nonValid') === -1 || (!ticket.valid && ticket.cadastroOnline && !ticket.reasonError)
        })
        .filter(ticket => {
          return this.filters.selected.indexOf('surveyed') === -1 || this.isTicketSurveyed(
            ticket)
        })
        .filter(ticket => {
          return this.filters.selected.indexOf('notSurveyed') === -1 || this.isTicketNotSurveyed(
            ticket)
        })
      this.loadingFiltered = false
    },

    getEvent (id) {
      if (this.event) {
        return this.event
      }

      if (this.events.hasOwnProperty(id)) {
        return this.events[id]
      }

      return {}
    },

    changeTickets (customerId) {
      console.log('event', this.event)
      console.log('events', this.events)
      if (this.event) {
        this.getTicketsByEvent(this.event._id)
      } else {
        this.getTicketsByCustomer(customerId)
      }
    },

    ticketEligible (ticket) {
      return ticket.eligible === true && (!this.isEventRanking || (this.isEventRanking && this.surveyValid(
        this.isTicketSurveyed(ticket))))
    },

    notEligible (ticket) {
      let survey = this.surveyTicket(ticket)
      return !ticket.eligible || (this.isEventRanking && this.surveyInvalid(
        survey) && this.isTicketSurveyed(ticket))
    },

    reasonTicket (ticket) {
      return ticket.hasOwnProperty('reasonNotEligible') ? `${ticket.reasonNotEligible}` : 'Não elegível.'
    },

    reasonSurvey (ticket) {
      let survey = this.surveyTicket(ticket)
      let text = ''
      if (survey && this.surveyInvalid(survey)) {
        if (survey.status !== 'FINISHED') {
          return '\nPesquisa não efetuada.'
        }
        if (survey.alert && survey.alert.toString() === 'true') {
          text += '\nCliente com alerta.'
        }
        if (survey.data.hasOwnProperty('absent') && survey.data.absent.toString() === 'true' && survey.data.reasonNotPresent && survey.data.reasonNotPresent !== null) {
          text += '\n' + survey.data.reasonNotPresent
        }
        if (survey.data.hasOwnProperty('accepted') && survey.data.accepted.toString() === 'false' && survey.data.reasonNotAccepted && survey.data.reasonNotAccepted !== null) {
          text += '\n' + survey.data.reasonNotAccepted
        }
      }
      return text
    },

    reason (ticket) {
      let reason = ''

      if (ticket.error) {
        reason = ticket.reasonError
      } else if (!ticket.eligible) {
        reason = ticket.reasonNotEligible
      } else {
        reason = this.reasonSurvey(ticket)
      }

      return this.reasonTicket(ticket) + reason ? ` - ${reason}` : ''
    },

    enableReplace (ticket) {
      return !ticket.documentedAt && ticket.winner && this.scope !== 'customer'
    },

    handleChangeCheckInWinner (index, ticket) {
      ticket.checkIn = !ticket.checkIn
      let classRemove = ticket.checkIn ? 'btn-success' : 'btn-info'
      let classAdd = !ticket.checkIn ? 'btn-success' : 'btn-info'
      document.getElementById(ticket._id + '-winner').disabled = true
      Couchdb.collection('tickets')
        .upsert(ticket._id, ticket)
        .then(() => {
          this.$notify({
            message: 'Presença registrada com sucesso.',
            type: 'success'
          })
          document.getElementById(ticket._id + '-winner')
            .classList
            .add(classAdd)
          document.getElementById(ticket._id + '-winner')
            .classList
            .remove(classRemove)
          document.getElementById(ticket._id + '-winner').disabled = false
        })
        .catch(() => {
          this.$notify({
            message: 'Ocorreu algum problema ao registrar a presença. Entre em contato com o suporte.',
            type: 'success'
          })
          document.getElementById(ticket._id + '-winner').disabled = false
        })
    },

    handleSearch (search) {
      this.search = search
      this.setTicketsFiltered()
    },

    hasOwnDeepProperty (obj, prop) { // @TODO: Trocar para Lodash
      if (typeof obj === 'object' && obj !== null) {
        if (obj.hasOwnProperty(prop)) {
          return true
        }
        for (let p in obj) {
          if (obj.hasOwnProperty(p) &&
            this.hasOwnDeepProperty(obj[p], prop)) {
            return true
          }
        }
      }
      return false
    },

    handleTicketPrint (index, ticket) {
      let routeData = this.$router.resolve({
        name: 'tickets.print',
        params: { id: ticket._id }
      })
      window.open(
        routeData.href,
        'ticketWindow',
        'menubar=false,location=false,resizable=false,scrollbars=1,status=false'
      )
    },

    handleDocumentation (row) {
      this.resetOne()
      this.$router.push({ name: 'tickets.details', params: { id: row._id } })
    },

    handleReplaceCustomer (index, row) {
      this.showReplacement = true
      this.replacementCustomerSync = false
      this.replacementCustomerSync = true
      this.winner = row
    },

    setFilters () {
      this.filters.selected = []
      if (this.event && this.event.drawn) {
        this.filters.selected.push('winner')
      }
    },

    isTicketSurveyed (ticket) {
      let survey = this.surveyTicket(ticket)
      return survey && ['FINISHED', 'SYNCED'].indexOf(survey.status) !== -1
    },

    isTicketNotSurveyed (ticket) {
      let survey = this.surveyTicket(ticket)
      return survey && ['TODO', 'CONFLICT'].indexOf(survey.status) !== -1
    },

    surveyTicket (ticket) {
      return this.isEventRanking ? this.surveys[ticket._id] : undefined
    },

    surveyValid (survey) {
      if (!survey) {
        return false
      }

      // É o mesma validação de quando se filtra as pesquisas para gerar o ranking
      return survey.status === 'FINISHED' &&
        (!survey.alert || survey.alert === 'false') &&
        survey.hasOwnProperty('data') &&
        (!survey.data.absent || survey.data.absent === 'false') &&
        (survey.data.accepted && survey.data.accepted !== 'false')
    },

    surveyInvalid (survey) {
      if (!survey) {
        return true
      }

      return survey.status !== 'FINISHED' ||
        (survey.alert && survey.alert.toString() === 'true') ||
        !survey.hasOwnProperty('data') ||
        (survey.data.hasOwnProperty('absent') && survey.data.absent.toString() === 'true') ||
        (survey.data.hasOwnProperty('accepted') && survey.data.accepted.toString() === 'false')
    }
  },

  created () {
  }
}
</script>
<style scoped>
  .el-select {
    width: 100%
  }
</style>



// WEBPACK FOOTER //
// src/pages/Tickets/TicketsList.vue